import React, { useState } from "react";
import * as url from "../../../helpers/url_helper";
import { convertLocalDate } from "../../../Utils/configController";
import FirmwareDataTable from "../Firmware/FirmwareDataTable";
import {
  Alert,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../../components/Common/Breadcrumb";

const TestingDetailsList = () => {
  const navigate = useNavigate();

  const [dataTableId, setDataTableId] = useState(null);
  const [isOpenAddTestingModel, setOpenAddTestingModel] = useState(false);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: "Testing",
      render: function (data: any, type: any, row: any) {
        return row?.userLable ? `${row?.userLable}` : "-";
      },
    },
    {
      title: "Hardware Version",
      render: function (data: any, type: any, row: any) {
        return row?.hardwareId?.hardwareVersion
          ? `${row?.hardwareId?.hardwareVersion}`
          : "-";
      },
    },
    {
      title: "Software Version",
      render: function (data: any, type: any, row: any) {
        return row?.firmwareId?.firmwareVersion
          ? `${row?.firmwareId?.firmwareVersion}`
          : "-";
      },
    },
    {
      title: "Status",
      render: function (data: any, type: any, row: any) {
        const statusBadge =
          row?.status === 0
            ? '<span class="font-size-11 badge-soft-danger badge bg-secondary">Pending</span>'
            : row?.status === 1
            ? '<span class="font-size-11 badge-soft-info badge bg-secondary">In Progress</span>'
            : row?.status === 2 &&
              '<span class="font-size-11  badge-soft-success badge bg-secondary">Completed</span>';

        return statusBadge;
      },
    },
    {
      title: "Passed",
      render: function (data: any, type: any, row: any) {
        return row?.scheduledDateTime
          ? convertLocalDate(row?.scheduledDateTime)
          : "-";
      },
    },
    {
      title: "Failed",
      render: function (data: any, type: any, row: any) {
        return row?.createdAt ? convertLocalDate(row?.createdAt) : "-";
      },
    },
    {
      title: "Detail",
      render: function (data: any, type: any, row: any) {
        return `<div class="d-flex gap-2">
                                <button class="edit-btn" style="border: none; outline: none; background: none;"><span class="badge bg-primary" style="height: 25px; width: 60px; font-size: 12px; padding: 6px;">Details</span></button>
                            </div>`;
      },
    },
  ];

  const handleDataTableIdChange = (dataTableId: any) => {
    setDataTableId(dataTableId);
  };

  const reloadDataTable = () => {
    if (dataTableId) {
      const dataTableInstance: any = $(`#${dataTableId}`).DataTable();
      dataTableInstance.ajax.reload(null, false);
    }
  };

  const toggleAddTestingModel = () => {
    setOpenAddTestingModel(!isOpenAddTestingModel);
  };

  const validation = useFormik({
    initialValues: {
      slave: "",
      formError: "",
    },
    validationSchema: Yup.object().shape({
      slave: Yup.string().required("Please provide your slave "),
    }),
    onSubmit: (values) => {},
  });

  const handleNavigateDetails = (rowData: any) => {
    navigate("/testing/testing-details-of-details/sdfsdf");
  };

  return (
    <div className="page-content" style={{ backgroundColor: "#fff" }}>
      <Breadcrumb
        title="Testing"
        breadcrumbItem={"Details of Testing"}
        state={{ isReload: true }}
        titleClick={"/testing"}
      />
      <Modal
        isOpen={isOpenAddTestingModel}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        // tabIndex="-1"
        toggle={toggleAddTestingModel}
      >
        <div className="modal-content">
          <ModalHeader style={{ justifyContent: "center" }}>
            Add Testing
            {/* {isEditable ? "Edit Area" : "Add Area"} */}
          </ModalHeader>
          <Form
            className="form-horizontal"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <ModalBody>
              {validation.errors && validation.errors.formError ? (
                <Alert color="danger">{validation.errors.formError}</Alert>
              ) : null}
              <div className="mb-3">
                <Label className="form-label">Slave</Label>
                <Input
                  value={validation.values.slave || ""}
                  name="slave"
                  type={"text"}
                  placeholder="Slave"
                  onBlur={validation.handleBlur}
                  onChange={validation.handleChange}
                  invalid={
                    validation.touched.slave && validation.errors.slave
                      ? true
                      : false
                  }
                />
                {validation.touched.slave && validation.errors.slave ? (
                  <span className="error">{validation.errors.slave}</span>
                ) : null}
              </div>
            </ModalBody>
            <ModalFooter style={{ justifyContent: "center" }}>
              <button className="btn btn-dark" type="submit" disabled={loading}>
                {loading ? "Saving..." : "Save"}
              </button>
            </ModalFooter>
          </Form>
        </div>
      </Modal>
      <FirmwareDataTable
        apiURL={`${url.BASE_URL}${url.PUSH_FIRMWARE_LIST}`}
        columns={columns}
        title={"Testing List"}
        onDataTableRefresh={handleDataTableIdChange}
        idName={"TestingDetailsList"}
        handleEditClick={handleNavigateDetails}
      />
    </div>
  );
};

export default TestingDetailsList;
